// The world never moves for the reveal: only the disposable arrival scenery does.
// No extra render loop, framebuffer, shader variant, camera change, or input capture.
export function createArrivalTransition({loading, eventTarget=window, motion=window.matchMedia('(prefers-reduced-motion: reduce)'), schedule=setTimeout, unschedule=clearTimeout, ready=()=>eventTarget.dispatchEvent(new Event('valoria:ready'))}={}) {
  let phase='waiting', timer=null;
  const animations=[];
  function cleanup() {
    if(timer!==null)unschedule(timer);
    timer=null;
    for(const animation of animations)animation.cancel();
    animations.length=0;
    eventTarget.removeEventListener('pagehide',finish);
    motion.removeEventListener?.('change',preference);
  }
  function finish() {
    if(phase==='done')return;
    phase='done';
    // Remove before cancelling fill animations so the loader cannot flash back.
    loading?.remove();
    cleanup();
  }
  function preference(event){if(event.matches&&phase==='revealing')finish();}
  function animate(element,keyframes,options){if(element?.animate)animations.push(element.animate(keyframes,{fill:'both',...options}));}
  function rendered({assetsReady=true}={}) {
    if(phase!=='waiting'||!assetsReady||!loading?.isConnected)return false;
    phase='revealing';
    ready(); // Freeze the inexpensive hills on precisely the first ready world frame.
    if(motion.matches){finish();return true;}
    loading.style.transition='none';
    // A restrained depth dissolve: the purple landscape opens outward while the
    // already-rendered destination appears underneath, without moving the player.
    const duration=980;
    if(!loading.animate){loading.style.transition='opacity .7s';loading.style.opacity='0';}
    else {
      animate(loading,[{opacity:1,offset:0},{opacity:.96,offset:.12},{opacity:.38,offset:.55},{opacity:0,offset:1}],{duration,easing:'cubic-bezier(.22,.7,.2,1)'});
      animate(loading.querySelector('.arrival-scenery'),[
        {transform:'perspective(1000px) translateZ(0) rotateX(0deg)',transformOrigin:'50% 56%'},
        {transform:'perspective(1000px) translateZ(95px) rotateX(2deg)',transformOrigin:'50% 56%'}
      ],{duration,easing:'cubic-bezier(.2,.7,.2,1)'});
      for(const child of loading.children??[])if(!child.classList?.contains('arrival-scenery'))
        animate(child,[{opacity:1},{opacity:0}],{duration:180,easing:'ease-out'});
    }
    timer=schedule(finish,duration+40);
    return true;
  }
  eventTarget.addEventListener('pagehide',finish,{once:true});
  motion.addEventListener?.('change',preference);
  return {rendered,cancel:finish,get phase(){return phase;}};
}
